import React from 'react';
import {Spinner} from 'react-bootstrap';

const SmallSpinner = props => {
    return (<Spinner animation="border" size="sm" {...props} />);
};

export default SmallSpinner;
